<template>
  <div
    style="min-height: calc(100vh - 136px)"
    v-loading="homeLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <!-- 可修改 页面 -->
    <!-- <div v-if="singleData.statusCheck == 0">
      <returnMaterialAdd
        :itemList="itemList"
        :returnMaterial_type="1"
        :addData="singleData"
        @backOrderState="getList()"
        @backHome="backHome"
      ></returnMaterialAdd>
    </div> -->
    <div>
      <div class="title">
        <div class="title--newFont">{{ $t("退料明细") }}</div>
        <div style="text-align: right">
          <el-button class="btnTwo" @click="backHome" size="small">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <div v-if="singleData.statusCheck == 1">
        <div class="checkImg">
          <img
            style="max-width: 100%; max-height: 100%"
            src="@/assets/images/examine.png"
          />
        </div>
      </div>
      <!-- 操作栏 -->
      <div style="margin-bottom: 10px">
        <div style="margin-bottom: 10px">
          <label>{{ $t("退料单号") }} </label>
          <span class="span">{{ singleData.outsourcingReturnDocNumber }}</span>
          <label>{{ $t("全局搜索码") }} </label>
          <span class="span">{{ singleData.globalSearchNumber }}</span>
          <label>{{ $t("退料日期") }} </label>
          <span class="span">{{ formatDate(singleData.baseReturnTime) }}</span>
          <label>{{ $t("退单人") }} </label>
          <span class="span">{{ singleData.baseDrawerName }}</span>
          <label>{{ $t("退货确认人") }} </label>
          <span class="span">{{ singleData.baseConfirmmanName }}</span>
        </div>
      </div>
      <!-- 内容 -->
      <div>
        <myTable
          :overflow="true"
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="itemList"
          :titleList="itemTitleList"
          :tableBtnList="itemTableBtnList"
          @btnClick="productBtnClick"
          @inputNumberClick="inputNumberClick"
          @cellClickEvent="cellClickEvent"
          :customListQuery="productListQuery"
          :customTitleList="productTitleList"
          :customList="productList"
          @customClick="productClick"
          @rowCustomClick="rowCustomClick"
          ref="myTableOne"
        ></myTable>
      </div>
      <div>
        <el-input
          type="textarea"
          disabled
          v-model="singleData.remark"
          :placeholder="$t('备注')"
          rows="5"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
import { outsorReturnDoc_view } from "@/api/myController/outsourcing";
import returnMaterialAdd from "@/views/outsourcingProduct/components/return_add.vue";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    homeIndex: {
      type: Number,
      default: false,
    },
    itemList: {
      default: [],
    },
    singleData: {
      default: {},
    },
  },
  components: { returnMaterialAdd },
  data() {
    return {
      btnLoading: false,
      homeLoading: false,
      hrefProData: {},
      // ---------------------------------
      dialogState: {
        show1: false,
        show2: false,
      },
      // ------------------------------
      proList: [],
      itemTableBtnList: [],
      itemTitleList: [
        {
          id: 0,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
        },
        {
          id: 1,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 6,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
        },
        {
          id: 10,
          name: this.$t("退料数量"),
          value: "baseReturnQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
      ],
      examineType: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    //
    getList() {
      this.homeLoading = true;
      outsorReturnDoc_view({
        outsourcingReturnDocId: this.routeQuery.outsourcingReturnDocId,
      }).then((res) => {
        res.data.data.outsorReturnDocDetailList.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
        });
        this.itemList = res.data.data.outsorReturnDocDetailList;
        this.singleData = res.data.data;
        this.homeLoading = false;
      });
    },
    formatDate(time) {
      return this.$moment(time).format("YYYY-MM-DD"); // 获取当前时间
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
.span {
  margin-right: 20px;
  color: #08a1b8;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 50px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}
</style>
